"use client";
import { useAppSelector } from "@/data/redux/store";
import useIsDarkMode from "@/hooks/framework/useIsDarkMode";
import MenuIcon from "@mui/icons-material/Menu";
import { Avatar, Button, IconButton, Menu, Stack } from "@mui/material";
import { useState } from "react";
import CommonMenuOptions from "./CommonMenuOptions";

export default function AuthenticationControl() {
  const authState = useAppSelector((state) => state.app.auth);
  const darkMode = useIsDarkMode();
  const [menuAnchorElement, setMenuAnchorElement] = useState(null);

  const openMenu = (e) => setMenuAnchorElement(e.currentTarget);

  return (
    <>
      {authState.loggedIn ? (
        <>
          <IconButton onClick={openMenu}>
            <Avatar
              sx={{
                backgroundColor: darkMode ? "primary.main" : "background.paper",
                color: darkMode ? "primary.contrastText" : "primary.main"
              }}
            >
              {authState.username?.slice(0, 1)?.toUpperCase()}
            </Avatar>
          </IconButton>
        </>
      ) : (
        <Stack direction="row">
          <Button color={darkMode ? "primary" : "inherit"} href={"/auth/signin"}>
            Sign In
          </Button>
          <IconButton color={darkMode ? "primary" : "inherit"} onClick={openMenu}>
            <MenuIcon />
          </IconButton>
        </Stack>
      )}
      <Menu
        open={Boolean(menuAnchorElement)}
        anchorEl={menuAnchorElement}
        onClose={() => setMenuAnchorElement(null)}
        slotProps={{
          paper: {
            elevation: 3,
            sx: {
              minWidth: "240px"
            }
          }
        }}
      >
        <CommonMenuOptions
          key="common"
          handleMenuClosed={() => {
            setMenuAnchorElement(null);
          }}
        />
      </Menu>
    </>
  );
}
